import { render, staticRenderFns } from "./MakeList.vue?vue&type=template&id=0588253e"
import script from "./MakeList.vue?vue&type=script&lang=js"
export * from "./MakeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports